export const jsxConstFunctions = {
  cancelRender: "$.__bodymovin1.bm_compsManager.cancel()",
  imageProcessed: `$.__bodymovin1.bm_sourceHelper.imageProcessed(%VALUE%,null)`,
  getJsonData: "$._blingsio.dataManager.getJsonData()",
  setFontData: "$.__bodymovin1.bm_renderManager.setFontData(%VALUE%)",
  renderComposition:  "$.__bodymovin1.bm_compsManager.renderComposition(%VALUE%)",
}

export const jsxConstsEvents = {
  cancelRender: "bm1:render:cancel",
  imageProcess: "bm1:image:process",
  renderStart: "bm1:render:start",
  renderComplete: "bm1:render:complete",
  renderFonts: "bm1:render:fonts",
  renderUpdate: "bm1:render:update",
  alert: "bm1:alert",
  console: "console:log"
}

